import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Modal from 'shared/modal';
import Button from 'shared/button';
import { faEnvelope } from '@fortawesome/pro-solid-svg-icons';
import { connect } from 'react-redux';
import { get } from 'helpers/api';
import { showSnackbar } from 'components/ui/snackbar/helper';

const MODAL_STATES = {
  DEFAULT: 'default',
  SENDING: 'sending',
  SENT: 'sent'
};

function EmailCaModal({ caDownloadPath, projectName, show, onClose }) {
  const [modalState, setModalState] = useState(MODAL_STATES.DEFAULT);

  async function sendEmailCa() {
    setModalState(MODAL_STATES.SENDING);
    await get(caDownloadPath);
    setModalState(MODAL_STATES.SENT);
    showSnackbar({ text: 'Preparing Documents for Email', variant: 'success' });
    onClose();
  }

  const sendButtonDisabled = modalState === MODAL_STATES.SENDING || modalState === MODAL_STATES.SENT;

  return (
    <Modal icon={faEnvelope} show={show} title="Email CA Activity" onHide={onClose}>
      <div className="text-center">
        <div>We will be sending you an email with a link to the lead's activity for
          <span className="fw-bold"> {projectName}.</span>
        </div>
        <div className="fw-bold">This link only will be valid for 24 hours</div>
      </div>
      <Modal.Footer footerOrientation="center">
        <Button.Cancel className="mr-3" type="button" onClick={onClose}>
          Cancel
        </Button.Cancel>
        <Button.Primary className="mr-3" disabled={sendButtonDisabled} type="button" onClick={sendEmailCa}>
          {modalState === MODAL_STATES.DEFAULT && 'Send'}
          {modalState === MODAL_STATES.SENDING && 'Sending...'}
          {modalState === MODAL_STATES.SENT && 'Sent'}
        </Button.Primary>
      </Modal.Footer>
    </Modal>
  );
}

EmailCaModal.propTypes = {
  caDownloadPath: PropTypes.string.isRequired,
  projectName: PropTypes.string.isRequired,
  show: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired
};

const mapStateToProps = props => ({ projectName: props.project.displayName });

export default connect(mapStateToProps)(EmailCaModal);
